export default __webpack_public_path__ + "1.19.2/static/media/green-check.c88ea47e.svg";